import React, { useEffect, useState } from 'react';
import Layout from '../templates/DefaultLayout';
import { SectionNav } from '~/components/Section';
import { MdLibraryBooks, MdMore, MdPrint, MdReceipt } from 'react-icons/md';
import { TiTickOutline } from 'react-icons/ti';
import { Switch , Redirect, Route } from 'react-router-dom';
import { titleOpinionContext, useAuth, useRouter, withTitleOpinion } from '~/hooks';
import { Card } from '~/components';
import { stringUtils } from '~/util';
const { hasValue } = stringUtils;
import { FileSection } from './sections/File';
import DeedOfTrust from './sections/DeedOfTust';
import NextPrevious from '~/components/Section/NextPrevious';
import { sectionApi, titleOpinionApi } from '~/api';
import AdditionalSection from './sections/Additional';
import { generateFTODocument } from './generateFTODoc';
import ReviewSection from './sections/Review';
import { FTO_STATUS, sectionTypes } from './sections';
import SubmissionConfirmation from './SubmissionConfirmation';
import { DateTime } from 'luxon';

const FinalTitleOpinion = () => {
    let { match, params, history } = useRouter('/finalopinion/:id');
    const url = match.url.replace(/\/+$/, '');

    const { isTryon } = useAuth();

    const [titleOpinion, setTitleOpinion] = useState(null);
    const [hasFileNumber, setHasFileNumber] = useState(false);
    const existingOpinion = titleOpinion && Object.keys(titleOpinion).length > 0;

    useEffect(() => {
        const getOpinion = async () => {
            if (params.id && params.id != 0) {
                const opinion = await titleOpinionApi.getTitleOpinion(params.id);
                setTitleOpinion(opinion);
                setHasFileNumber(true);
            }
        };

        getOpinion();
    }, [params.id]);

    const submitted = (titleOpinion && titleOpinion.statusId == FTO_STATUS.SUBMITTED) ? true : false;
    const readonly = isTryon || submitted;

    const ctxValue = {
        titleOpinion,
        existingOpinion,
        titleOpinionId: params.id,
        readonly,
        submitted,
        hasFileNumber
    };

    const printFTODOC = async() => {
        await titleOpinionApi.getFinalTitleOpinionDocData(params.id)
            .then((ftoData) => {
                generateFTODocument({ftoData, titleOpinionId: params?.id ,isPrintOnly: true});
            });
    };

    const submitFTO = async () => {
        const { _data: reviewData } = await sectionApi.getSection(titleOpinion.id, sectionTypes.REVIEW);

        const hasSectionError = Object.keys(reviewData.sectionErrors)
            .reduce(
                (result, e) => result || reviewData.sectionErrors[e],
                false
            );

        const hasAttorney = hasValue(reviewData.approvingAttorney);
        
        if (hasSectionError || !hasAttorney) {
            alert('Please complete the Final Title Opinion request to submit');
        } else {
            try {

                const submitResult = await titleOpinionApi.submitFTO(titleOpinion.id);
                if (submitResult.errored) {
                    throw new Error(submitResult.error ?? "error submitting FTO");
                }
                
                await titleOpinionApi.getFinalTitleOpinionDocData(titleOpinion.id)
                    .then(data => generateFTODocument({ ftoData: data, titleOpinionId: titleOpinion.id, isPrintOnly: false }))
                    .catch(err => {
                        console.error('Issue generating FTO document', err);
                    });
                
                await titleOpinionApi.sendEmailOnSubmitFTO(titleOpinion.id);
                
                history.push(`${url}/submit`);
            } catch (e) {
                console.error('Something went wrong', e);
                alert("An error occurred. FTO could not be submitted.");
            }
            // .then(() => {
            //     return titleOpinionApi.getFinalTitleOpinionDocData(titleOpinion.id)
            //         .then((data) => {
            //             return Promise.all([generateFTODocument({ftoData: data, titleOpinionId: titleOpinion.id, isPrintOnly: false})]);
            //         });
            // })
            // .then(() => {
            //     return titleOpinionApi.sendEmailOnSubmitFTO(titleOpinion.id);
            // })
            // .then(() => {
            //     history.push(`${url}/submit`);
            // });
        }
    };

    return (
        <Layout>
            <titleOpinionContext.Provider value={ctxValue}>
                <div className='container h-full flex flex-col'>
                    <div className='flex justify-between'>
                        <h1 className='text-blue-60 text-3xl font-semibold mt-12'>Final Title Opinion</h1>
                        <button 
                            className="mt-12 py-2 px-4 flex justify-between items-center rounded-md bg-blue-50 text-white focus:outline-none"
                            onClick={printFTODOC}
                        >
                            <MdPrint size="1em" className="mr-1" />
                            PRINT
                        </button>
                    </div>
                    <SectionNav>
                        <SectionNav.Link to={`${url}/file`} icon={MdLibraryBooks} text='File &amp; Deed Information' />
                        <SectionNav.Link to={`${url}/deed`} icon={MdReceipt} text='Deed of Trust' />
                        <SectionNav.Link to={`${url}/additional`} icon={MdMore} text='Additional Information' />
                        <SectionNav.Link to={`${url}/review`} icon={TiTickOutline} text='Final Review' />
                    </SectionNav>
                    <Card className='flex-1 my-8 roundeed-md py-4 px-2'>
                        <div className='flex flex-col h-full items-stretch'>
                            { ( ctxValue.submitted && !/\/submit$/i.test(history.location.pathname) ) && (
                                <div className='bg-success-10 p-2 mx-4 mb-4 rounded-md text-sm text-green-800'>
                                    <p>
                                        Submitted on {DateTime.fromISO(titleOpinion.submitted).toLocal().toLocaleString(DateTime.DATETIME_SHORT)}{' '}
                                        by {`${titleOpinion.submittedBy.firstName} ${titleOpinion.submittedBy.lastName}`}
                                    </p>
                                </div>
                            )}
                            <Switch>
                                <Redirect path={match.url} exact to={`${url}/file`} />
                                <Route path={`${url}/file`} component={() => withTitleOpinion(FileSection)}/>
                                <Route path={`${url}/deed`} component={() => withTitleOpinion(DeedOfTrust)}/>
                                <Route path={`${url}/additional`} component={() => withTitleOpinion(AdditionalSection)}/>
                                <Route path={`${url}/review`} component={() => withTitleOpinion(ReviewSection)}/>
                                <Route path={`${url}/submit`} component={() => withTitleOpinion(SubmissionConfirmation)}/>
                            </Switch>
                            <NextPrevious 
                                sections={['file', 'deed', 'additional', 'review']} 
                                canSubmit={(titleOpinion && titleOpinion.statusId == FTO_STATUS.DRAFT)}
                                submit={submitFTO}
                            />
                        </div>
                    </Card>
                </div>
            </titleOpinionContext.Provider>
        </Layout>
    );
};

export default FinalTitleOpinion;